/**
 * Persist the given data in local storage. The data object
 * will be stringified.
 *
 * @param {string} key The storage key
 * @param {Object} data The data (will be JSON stringified)
 */
export function persist (key, data) {
  if (!window.localStorage) return;
  window.localStorage.setItem(key, JSON.stringify(data));
}

/**
 * @param {string} key The data key
 * @returns {Object|null} The loaded data or null
 */
export function load (key) {
  if (!window.localStorage) return null;
  const raw = window.localStorage.getItem(key);
  if (raw === null || raw === undefined) {
    return null;
  }
  return JSON.parse(raw);
}
